import { useRef, useState } from "react";
import { Layout } from "react-grid-layout";
import { DashboardGridItem } from "../../services/types";
import DraggableDashboardReportCategory from "../Reports/DashboardReportCategory";
import DraggableDashboardReportPayment from "../Reports/DashboardReportPayment";
import DraggableDashboardReportProduct from "../Reports/DashboardReportProduct";
import DraggableDashboardReportSales from "../Reports/DashboardReportSales";
import DraggableDashboardReportSalesAdvanced from "../Reports/DashbordReportSalesAdvanced";

const DashboardExtendedTab = () => {
	const ref = useRef<HTMLDivElement>(null);
	const [state, setState] = useState<Layout[]>([]);

	return (
		<>
			<DraggableDashboardReportSalesAdvanced
				key={DashboardGridItem.SALES_ADVANCED}
				ref={ref}
				setNonMobileLayout={setState}
			/>
			<div className="card-columns">
				<DraggableDashboardReportPayment
					key={DashboardGridItem.PAYMENT}
					ref={ref}
					setNonMobileLayout={setState}
				/>
				<DraggableDashboardReportProduct
					key={DashboardGridItem.PRODUCT}
					ref={ref}
					setNonMobileLayout={setState}
				/>
				<DraggableDashboardReportCategory
					key={DashboardGridItem.CATEGORY}
					ref={ref}
					setNonMobileLayout={setState}
				/>
				<DraggableDashboardReportSales key={DashboardGridItem.SALES} ref={ref} setNonMobileLayout={setState} />
			</div>
		</>
	);
};

export default DashboardExtendedTab;
